import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';

import styles from './LanguageSelect.module.scss';
import { Option } from './Option/Option';
import { Placeholder } from './Placeholder/Placeholder';
import { SingleValue } from './SingleValue/SingleValue';
import type { LanguageOption } from './types';

type Props = {
  value: LanguageOption | null;
  onChange: (value: LanguageOption | null) => void;
  options: LanguageOption[];
  disabled?: boolean;
  name?: string;
  hideDropdownArrow?: boolean;
  customStyles?: {
    languageName?: React.CSSProperties;
    singleValue?: React.CSSProperties;
    icon?: React.CSSProperties;
    option?: React.CSSProperties;
    menu?: React.CSSProperties;
    menuList?: React.CSSProperties;
  };
  showShortLanguageCode?: boolean;
  showSingleValuePrefixIcon?: boolean;
  customStylesWrapper?: React.CSSProperties;
};
export function LanguageSelect(props: Props) {
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.wrapper}>
        <Select
          classNames={{
            container: () => styles.container,
            control: (selectState) =>
              classNames(styles.control, {
                [styles.openMenuControl]: selectState.menuIsOpen,
              }),
            valueContainer: () => styles.valueContainer,
            menu: () => styles.menu,
            menuList: () => styles.menuList,
          }}
          components={{
            Option,
            SingleValue,
            Placeholder,
            IndicatorSeparator: () => null,
            ...(props.hideDropdownArrow && { DropdownIndicator: () => null }),
          }}
          getOptionLabel={(option) => option.name}
          getOptionValue={(option) => option.id}
          isClearable={false}
          isDisabled={props.disabled}
          isSearchable={false}
          name={props.name}
          options={props.options}
          placeholder={t('profile.selectLanguage')}
          showShortLanguageCode={props.showShortLanguageCode}
          showSingleValuePrefixIcon={props.showSingleValuePrefixIcon}
          styles={{
            container: (provided) => ({
              ...provided,
              ...props.customStylesWrapper,
            }),
            menu: (provided) => ({
              ...provided,
              ...props.customStyles?.menu,
            }),
          }}
          value={props.value}
          onChange={(newValue) => props.onChange(newValue as LanguageOption | null)}
          {...(props.customStyles ? { customStyles: props.customStyles } : {})}
        />
      </div>
    </>
  );
}
